import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'em-input-error-message',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './input-error-message.component.html',
  styleUrl: './input-error-message.component.scss',
})
export class InputErrorMessageComponent {
  @Input() errorMessage!: string;
}
